import React from "react";

import { Props } from "./types";

function ClosedFolderIcon({ className, style }: Props) {
  return (
    <svg className={className} style={style} viewBox="0 0 15.004 12.697">
      <path
        d="M13.155,41.668H8.406a.717.717,0,0,1-.511-.214L6.414,39.894a1.878,1.878,0,0,0-1.337-.538H1.849A1.851,1.851,0,0,0,0,41.2v9a1.851,1.851,0,0,0,1.849,1.849H13.164A1.851,1.851,0,0,0,15,50.2V43.517A1.851,1.851,0,0,0,13.155,41.668Zm.718,8.533a.719.719,0,0,1-.712.721H1.849a.719.719,0,0,1-.718-.718v-9a.72.72,0,0,1,.718-.719H5.11a.713.713,0,0,1,.5.2l1.474,1.554a1.857,1.857,0,0,0,1.327.562h4.749a.719.719,0,0,1,.718.718V50.2Z"
        transform="translate(0 -39.356)"
      />
    </svg>
  );
}

export { ClosedFolderIcon };
